<template lang="html">
  <div class="row pt-4 price-tab-content">
    <div class="col-sm-9 col-md-8 offset-md-4 mb-lg-5">
      <label for="" style="font-size: 20px" class="font-weight-bold">
        Precio
       <sup class="required-tip">*</sup>
      </label>
      <small v-if="errors.linkML" class="text-danger font-weight-bold d-block">
        Ha ocurrido un error enlanzando con Mercadopago
      </small>
      <div class="form-row align-items-center">
        <div class="col-4 col-md-2">
          <select
            @focus="$emit('focus')"
            @blur="$emit('blur')"
            :value="currencyCode"
            @change="handleCurrencyChange"
            class="form-control">
            <option value="USD">U$S</option>
            <option value="ARS">Pesos</option>
          </select>
        </div>
        <div class="col-8 col-md-5">
          <input
            @focus="$emit('focus')"
            @blur="$emit('blur')"
            :value="currencyValue"
            placeholder="Ingresá el precio"
            type="number"
            @input="handlePriceInput"
            class="form-control">
        </div>
      </div>
      <small v-if="(nextPressed && (!validPriceAmount(currencyValue) || !currencyValue))" class="text-danger">
        Ingresá un número mayor a uno y máximo dos decimales
      </small>

      <!-- Direct buy flow -->
      <div v-if="marketplace === true && category_marketable === true">

        <p class="mt-3 font-weight-bold">Tipo de Publicación</p>

        <RadioTooltip
          @change="handleRadio"
          :checked="forSale === 0"
          label="Publicación de Clasificado"
          tooltip="Publicación de clasificado tradicional. Los visitantes tendrán que contactarte para poder comprar tu artículo"
          name="forSale"
          value="0" />

        <div v-if="!directSellEnabled" @click="clickForSaleDisable" class="div-radio-for-sale-disabled"></div>

        <RadioTooltip
          @change="handleRadio"
          :checked="forSale === 1"
          :disabled="!directSellEnabled"
          label="Venta Online"
          tooltip="Permite compras online. El dinero ingresa directamente a tu cuenta de MercadoPago"
          name="forSale"
          value="1"
        />

        <Tooltip text="Para vender online el precio debe estar en pesos"
          :position="'right'"
          :active="openToolTipForSale"
          @close="handleCloseTooltipForSale"
          gray
        />

        <div :class="`mp-info ${forSale === 1 ? 'expand' : ''}`">

          <div class="my-4" v-if="!mercadopagoLinkedAccount">
            <p>Para poder crear una venta online tenés que enlazar tu cuenta de <span class="text-primary"><strong>Mercado Pago</strong></span></p>

            <button class="btn btn-info col-sm-12 col-md-5" @click="goToUserProfile">
              Enlazar cuenta de Mercado Pago
            </button>
          </div>
<!--          <p class="mt-3">Una publicación de venta online significa que los usuarios van a poder comprar el producto o servicio directamente-->
<!--            en nuestro sitio. El comprador tiene los beneficios de pagar con tarjeta de crédito en varias cuotas (según disponibilidad)</p>-->
          <br>

          <small v-if="error.priceGroup" class="text-danger">
            Ingresá los datos de precio completos
          </small>

          <div v-if="mercadopagoLinkedAccount" class="row text-left">
            <div class="col-12 col-sm-6 col-md-3">
              <div class="form-group px-sm-0 pt-3">
                <label for="price-quantity" class="font-weight-bold">Cantidad</label>
                <input
                  id="price-quantity"
                  type="number"
                  @focus="$emit('focus')"
                  @blur="$emit('blur')"
                  @input="handleStockInput"
                  :value="$store.state.sell.stock"
                  class="form-control"
                >
                <small v-if="nextPressed && !validStock" class="text-danger">
                  Este campo debe ser mayor a cero
                </small>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4 pt-0 pt-md-3">
              <div class="form-group px-sm-0">
                <label for="select-delivery" class="font-weight-bold">Envío</label>
                <select
                  id="select-delivery"
                  class="form-control"
                  @change="handleShippingType"
                  :value="shippingType"
                >
                  <option v-for="(shippingType, index) in shippingTypeList" :key="index" :value="shippingType.value">
                    {{ shippingType.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="forSale == 0 || (mercadopagoLinkedAccount)" class="mx-auto mt-auto mt-lg-3 text-center col-sm-12">
      <SquaredButton
        @click="goToDescription"
        styleType="link"
        label="Anterior" />
      <SquaredButton
        v-if="true"
        @click="forSale == 1 ? goToDetailPayment() : goToConfirmation()"
        styleType="primary"
        :label="editingPub ? 'Guardar y continuar' : 'Siguiente'" />
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { cleanAmountInput, validPriceAmount, cleanIntegerInput } from '@/helpers'

export default {
  props: {
    isReady: Boolean,
    errors: Object
  },

  data: () => ({
    error: {
      priceGroup: false,
    },
    nextPressed: false,
    openToolTipForSale: false
  }),
  computed: {

    marketplaceEnabled: () => store.getters['user/marketplaceEnabled'],

    mercadopagoLinkedAccount: () => store.state.user.mercadopago_linked_account,

    currencyCode: () => store.state.sell.price.currency_code,

    currencyValue: () => store.state.sell.price.currency_value,

    visibility: () => store.getters['sell/visibility'],

    stock: () => store.state.sell.stock,

    forSale: () => parseInt(store.state.sell.forSale),

    shippingType: () => store.state.sell.shipping_type,

    shippingTypeList: () => store.state.shippingTypeList,

    validStock () {
      return this.forSale === 0 || this.forSale === 1 && this.stock > 0
    },

    editingPub () {
      return this.$route.name === 'editPublication'
    },

    mercadoPagoSrc () { return this.$CDN_STATIC + '/static/img/mercadopago.png' },

    marketplace: () => store.state.user.marketplace,

    category_marketable: () => store.state.sell.category_marketable,

    directSellEnabled () {
      return this.currencyCode === 'ARS' && this.marketplaceEnabled && this.mercadopagoLinkedAccount && this.category_marketable
    },

  },
  watch: {
    marketplace (newValue) {
      if(!newValue) {
        store.dispatch('sell/setForSale', 0)
      }
    }
  },

  methods: {
    cleanAmountInput,

    validPriceAmount,

    cleanIntegerInput,

    goToDescription () {
      if (this.editingPub && !this.isReady) {
        this.nextPressed = true //controls error messages
      } else {
        this.$emit('goToDescription')
      }
    },

    goToUserProfile () {
      this.$router.push({ name: 'userProfile' });
    },

    goToDetailPayment () {
      this.nextPressed = true
      if(!this.currencyValue || !validPriceAmount(this.currencyValue)) {
        return false;
      }
      this.$emit('goToDetailPayment')
    },

    goToConfirmation () {
      this.nextPressed = true
      if (this.isReady) {
        this.$emit('goToConfirmation')
      }
    },

    handleCurrencyChange (e) {
      if (e.target.value !== 'ARS') {
        store.dispatch('sell/setForSale', 0)
      }
      store.dispatch('sell/setPriceCurrency', e.target.value)
    },

    handleRadio (name, value) {
      this.forSale = value
      store.dispatch('sell/setForSale', value)
    },

    handlePriceInput (e) {
      // this.cleanAmountInput(e)
      const value = e.target && e.target.value
      store.dispatch('sell/setPriceValue', value)
    },

    handleShippingType (e) {
      const value = e.target && e.target.value
      store.dispatch('sell/setShippingType', value)
    },

    /** Direct buy flow */
    handleStockInput (e) {
      this.cleanIntegerInput(e)
      store.dispatch('sell/setStock', e.target.value)
    },

    clickForSaleDisable () {
      this.openToolTipForSale = true
    },

    handleCloseTooltipForSale () {
      this.openToolTipForSale = false
    }
  }
}
</script>

<style lang="scss">
@import '../../../scss/breakpoints';

.price-tab-content {
  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    min-height: 70vh
  }

  @media screen and (min-width: map-get($grid-breakpoints, "sm")) {
    min-height: 40vh
  }

  @media screen and (min-width: map-get($grid-breakpoints, "lg")) {
    min-height: unset;
  }
}

.div-radio-for-sale-disabled{
  // border: 1px solid #000;
  height:28px;
  width: 200px;
  display:block;
  position: absolute;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/tabs/TabPrice.vue